import script from "./Reports.vue?vue&type=script&setup=true&lang=js"
export * from "./Reports.vue?vue&type=script&setup=true&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=737a1b30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-737a1b30"]])

export default __exports__